module.exports = "https://bin.bnbstatic.com/_next/static/images/warning-abd9a6ebb0f0c5d76b631cfe7379c4d2.svg";